import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@/i18n/config";
import { initSentry, Sentry } from "@/lib/sentry";

initSentry();

const CrashFallback = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "1rem",
      padding: "2rem",
      textAlign: "center",
      background: "#0a0f0d",
      color: "#e5e7eb",
      fontFamily: "system-ui, sans-serif",
    }}
  >
    <p style={{ fontSize: "1.125rem", fontWeight: 600 }}>Something went wrong.</p>
    <p style={{ color: "#9ca3af", maxWidth: "28rem" }}>
      This has been reported automatically. Try reloading the page.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: "0.5rem 1.25rem",
        borderRadius: "0.5rem",
        border: "none",
        background: "#22c55e",
        color: "#052e16",
        fontWeight: 600,
        cursor: "pointer",
      }}
    >
      Reload
    </button>
  </div>
);

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<CrashFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
